/* ======================================================================
   Winkler — <shopify-account> login popover RTL + Hebrew patch
   ----------------------------------------------------------------------
   Loaded from sections/header.liquid. The account popover (header icon +
   mobile sidebar) is Shopify's hosted <shopify-account> web component; its
   login form lives in nested OPEN shadow roots, so theme CSS can never
   reach it, and the component's internal reset forces direction: ltr even
   on this RTL store. Its stylesheets are fully logical-property based
   (inset-inline-*, :dir(rtl) rules), so restoring direction: rtl inside
   each shadow root flips the whole form natively — email label to the
   right, submit arrow to the inline-end (left, mirrored), and the
   marketing-consent checkbox to the right of its label.

   The "Email" label/placeholder ships untranslated, so it is swapped for
   "אימייל" here. The component re-renders its shadow content (e.g. when
   the dialog reopens), which wipes both patches — a MutationObserver on
   each shadow root re-applies them. All writes are guarded by value
   checks so the observer never loops on its own mutations.
   ====================================================================== */
(() => {
  var IS_RTL = document.documentElement.dir === 'rtl';
  var IS_HEBREW = (document.documentElement.lang || '').toLowerCase().indexOf('he') === 0;
  if (!IS_RTL && !IS_HEBREW) return;

  var EMAIL_HE = 'אימייל';
  var patched = new WeakSet();

  function injectRtlStyle(root) {
    if (!IS_RTL || root.querySelector('style[data-wk-rtl]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-wk-rtl', '');
    /* The component's adopted stylesheets outrank shadow-tree <style> tags on
       ties, and they pin direction on the <dialog> itself (heading + close
       button row) — that one needs !important to flip. */
    style.textContent =
      ':host, #shopify-element-wrapper { direction: rtl; }' +
      ' dialog { direction: rtl !important; }';
    root.appendChild(style);
  }

  function translate(root) {
    if (!IS_HEBREW) return;
    var input = root.querySelector('.login-form__email-input');
    var label = root.querySelector('.login-form__email-label');
    if (input && input.placeholder !== EMAIL_HE) input.placeholder = EMAIL_HE;
    if (label && label.textContent !== EMAIL_HE) label.textContent = EMAIL_HE;
  }

  function patchRoot(root) {
    injectRtlStyle(root);
    translate(root);
    new MutationObserver(function () {
      injectRtlStyle(root);
      translate(root);
      findNestedComponents(root);
    }).observe(root, { childList: true, subtree: true });
  }

  /* The login form (<shopify-login-form>) mounts lazily inside the
     account element's shadow root, each with its own shadow root. */
  function findNestedComponents(root) {
    root.querySelectorAll('shopify-login-form, shopify-login-form-loader').forEach(patchElement);
  }

  function patchElement(el) {
    if (patched.has(el)) return;
    patched.add(el);
    /* The shadow root may attach after the element upgrades. */
    (function waitForShadow(tries) {
      if (el.shadowRoot) {
        patchRoot(el.shadowRoot);
        findNestedComponents(el.shadowRoot);
      } else if (tries < 100) {
        setTimeout(function () { waitForShadow(tries + 1); }, 50);
      }
    })(0);
  }

  customElements.whenDefined('shopify-account').then(function () {
    document.querySelectorAll('shopify-account').forEach(patchElement);
  });
})();
